// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgDescriptorMyGender: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path
          fillRule="evenodd"
          d="M12 21.994h.034c1.918.033 3.76-.191 5.157-.631 1.492-.47 1.964-1.013 2.056-1.23.004-.026.016-.156-.076-.444-.123-.382-.383-.884-.806-1.472-.846-1.175-2.142-2.411-3.473-3.341l-1.05-.735a1 1 0 0 1-.083-1.574l.968-.84c.684-.594 1.462-1.935 1.462-5.2C16.19 4.042 14.285 2.096 12 2c-2.285.096-4.19 2.042-4.19 4.525 0 3.266.78 4.607 1.463 5.2l.968.84a1 1 0 0 1-.083 1.575l-1.05.735c-1.33.93-2.626 2.166-3.473 3.34-.423.589-.683 1.091-.806 1.473-.092.288-.08.418-.076.444.092.217.564.76 2.056 1.23 1.397.44 3.24.664 5.157.631zm9.118-1.154c-.85 2.205-4.981 3.224-9.118 3.154-4.137.07-8.268-.949-9.118-3.154-.647-1.678 1.179-4.311 3.49-6.35a18.08 18.08 0 0 1 1.59-1.254 5.075 5.075 0 0 1-1.21-1.594c-.596-1.196-.941-2.85-.941-5.116C5.81 2.982 8.566.097 12 0c3.434.097 6.19 2.982 6.19 6.526 0 2.266-.346 3.92-.943 5.116a5.073 5.073 0 0 1-1.209 1.595c.54.377 1.077.8 1.59 1.253 2.311 2.039 4.137 4.672 3.49 6.35"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgDescriptorMyGender);
export default Memo;
